import cx from 'classnames';
import {useRouter} from 'next/router';
import React, {useRef} from 'react';

import {useBreakpoint} from '@udemy/hooks';
import MenuIcon from '@udemy/icons/dist/menu.ud-icon';
import {IconButton, Image} from '@udemy/react-core-components';
import {Badge} from '@udemy/react-messaging-components';
import {MinimalHeader} from '@udemy/react-structure-components';

import MobileNav from '@udemy-django-static/js/header-v6/udlite/mobile/mobile-nav/mobile-nav.react-component';

import styles from './header.module.less';

// We use a custom logo so don't need any of the MX/UB logo logic for now
const renderLogo = () => (
    <span className={cx(styles['logo-container'], styles['logo-extra'])}>
        <a href={process.env.DEPLOY_BASE_PATH}>
            <Image
                height={34}
                width={91}
                alt="Udemy"
                src={`/${process.env.APP_NAME}/staticx/udemy/images/v7/logo-udemy.svg`}
            />
        </a>
        <p>/developer</p>
        <Badge className={styles['logo-badge']}>Beta</Badge>
    </span>
);

export const Header = () => {
    const router = useRouter();
    const breakpoint = useBreakpoint({
        mobile: 800,
        desktop: 9999,
    });
    const navRef = useRef(null);

    return breakpoint === 'desktop' ? (
        <div className={styles['desktop-only']}>
            <MinimalHeader renderLogo={renderLogo} className={styles['header-container']}>
                <div className={styles['header-links']}>
                    {/* Legacy behavior is necessary for passing className */}
                    <a
                        href={`${process.env.DEPLOY_BASE_PATH}/api-reference/`}
                        className={cx(styles['header-link'], {
                            [styles['active']]: router.asPath.includes('/api-reference'),
                        })}
                    >
                        API Reference
                    </a>
                    <a
                        href={`${process.env.DEPLOY_BASE_PATH}/changelog/`}
                        className={cx(styles['header-link'], {
                            [styles['active']]: router.asPath.includes('/changelog'),
                        })}
                    >
                        Changelog
                    </a>
                    <a
                        href={`${process.env.DEPLOY_BASE_PATH}/api-clients/`}
                        className={cx(styles['header-link'], {
                            [styles['active']]: router.asPath.includes('/api-clients'),
                        })}
                    >
                        API Clients
                    </a>
                </div>
            </MinimalHeader>
        </div>
    ) : (
        <div className={styles['mobile-only']}>
            <MinimalHeader renderLogo={renderLogo} className={styles['header-container']}>
                <IconButton udStyle="ghost" cssToggleId="header-toggle-side-nav">
                    <MenuIcon color="neutral" label={gettext('Open side drawer')} />
                </IconButton>
                {/* @ts-expect-error: ts <-> js */}
                <MobileNav ref={navRef}>
                    {/* @ts-expect-error: ts <-> js */}
                    <MobileNav.SectionHeading>Developer Hub</MobileNav.SectionHeading>
                    {/* @ts-expect-error: ts <-> js */}
                    <MobileNav.Section>
                        {/* @ts-expect-error: ts <-> js */}
                        <MobileNav.Item
                            href={`${process.env.DEPLOY_BASE_PATH}/api-reference/`}
                            className={cx(styles['header-link'], {
                                [styles['active']]: router.asPath.includes(
                                    process.env.DEPLOY_BASE_PATH + '/api-reference',
                                ),
                            })}
                        >
                            API Reference
                            {/* @ts-expect-error: ts <-> js */}
                        </MobileNav.Item>
                        {/* @ts-expect-error: ts <-> js */}
                        <MobileNav.Item
                            href={`${process.env.DEPLOY_BASE_PATH}/changelog/`}
                            className={cx(styles['header-link'], {
                                [styles['active']]: router.asPath.includes(
                                    process.env.DEPLOY_BASE_PATH + '/changelog',
                                ),
                            })}
                        >
                            Changelog
                            {/* @ts-expect-error: ts <-> js */}
                        </MobileNav.Item>
                        {/* @ts-expect-error: ts <-> js */}
                        <MobileNav.Item
                            href={`${process.env.DEPLOY_BASE_PATH}/api-clients/`}
                            className={cx(styles['header-link'], {
                                [styles['active']]: router.asPath.startsWith(
                                    process.env.DEPLOY_BASE_PATH + '/api-clients',
                                ),
                            })}
                        >
                            API Clients
                            {/* @ts-expect-error: ts <-> js */}
                        </MobileNav.Item>
                        {/* @ts-expect-error: ts <-> js */}
                    </MobileNav.Section>
                </MobileNav>
            </MinimalHeader>
        </div>
    );
};
